import { Link } from "react-scroll";
import { motion } from "motion/react";
import Pdf from "../../document/JamesTan_Resume.pdf";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import PhoneAnimation from "./FloatingPhone";

export default function HeroSection() {
  const [text] = useTypewriter({
    words: ["Full-Stack", "Web", "Mobile", "Next Js"],
    loop: {},
    typeSpeed: 100,
    deleteSpeed: 40,
  });

  return (
    <section id="heroSection" className="hero--section">
      <div className="hero--section--content--box">
        <div className="hero--section--content">
          <p className="section--title">Hey, I'm Jun Da</p>

          <h1 className="hero--section--title">
            <span className="hero--section-title--color">{text}</span>
            <span>
              <Cursor cursorStyle="|" />
            </span>
            <br />
            Developer
          </h1>
          <p className="hero--section-description">
            Welcome to my creative world. Enjoy browsing!
            <br />
            <p>You've got questions, I got answers.</p>
          </p>
        </div>
        <div>
          <Link to="Contact" className="btn btn-primary">
            Get In Touch
          </Link>
          <button className="btn btn-primary">
            <a href={Pdf} download="JamesTan_Resume">
              Download CV
            </a>
          </button>
        </div>
      </div>
      <PhoneAnimation />
    </section>
  );
}
